// src/components/ui/layout/AuthCard/AuthCard.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const AuthCard = ({
  children,
  className = '',
  maxWidth = 'md', // sm, md, lg, xl
  padding = 'default' // sm, default, lg
}) => {
  // Max width configurations
  const maxWidthConfig = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };

  // Padding configurations
  const paddingConfig = {
    sm: 'p-6',
    default: 'p-8',
    lg: 'p-10'
  };

  // Main card styles matching the login page
  const cardStyles = cn(
    // Layout
    "relative w-full overflow-hidden rounded-2xl",
    maxWidthConfig[maxWidth],
    paddingConfig[padding],
    
    // Glassmorphism effect
    "bg-slate-900/80 backdrop-blur-xl border border-slate-700/50",
    
    // Shadow
    "shadow-2xl shadow-black/25",
    
    className
  );

  return (
    <div className={cardStyles}>
      {/* Glassmorphism overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />
      
      {/* Content */}
      <div className="relative">
        {children}
      </div>
    </div>
  );
};

export default AuthCard;